import React, { useContext } from "react";
import { GateOutContext } from "../GateOutView";
import ContentFile from "../../../../constants/contentFile.json";
import DetailsCard from "../../../../components/DetailsCard/DetailsCard";
import Button from "../../../../components/ButtonComponent/Button";
import PhotoUpload from "../../../../components/PhotoUploadComponent/PhotoUpload";
import { SideMenu } from "../../../../components/sideMenu/SideMenu";
import { InputBox } from "../../../../components/InputField/inputFiled";
import AlertBox from "../../../../components/alertComponent/AlertBox";
import "./gateOut.css";
import Spinner from "../../../../components/spinner/Spinner";
const GateOut = () => {
  const {
    vehicleNumber,
    errorMsg,
    onChangeVehicleNumber,
    handleCapturedImage,
    capturedImage,
    submitGateOutData,
    details,
    isButtonEnabled,
    imageErrorMsg,
    successAlert,
    setSuccessAlert,
    popUpMessages,
    errorAlert,
    setErrorAlert,
    apiStatus,
  } = useContext(GateOutContext);

  const Contents = ContentFile.gateInOutPage;
  return (
    <div className="mainContainerDetail gateOutContainer">
      <div className="itemBoxDetail">
        <div className="col-xl-11 col-lg-11 col-md-12 col-sm-12 col-10 mainBoxDetail ">
          {apiStatus === "fetching" ? <Spinner /> : null}
          <h5 className="titleDetail">{Contents.gateOut}</h5>
          <DetailsCard details={details} />
          {/* <h5 className="titleDetail">{Contents.vehicleNumber}</h5> */}
          {/* <InputBox
            value={vehicleNumber}
            onChange={(event) => {
              onChangeVehicleNumber(event.target.value);
            }}
          />  */}
          {/* {errorMsg && <p className="errorText">{errorMsg}</p>} */}
          <PhotoUpload
            onImageCapture={handleCapturedImage}
            isSectionEnabled={isButtonEnabled}
          />
          {imageErrorMsg && <p className="errorText">{imageErrorMsg}</p>}

          {capturedImage && <p>{Contents.imageUploadMessage}</p>}
          <Button text={Contents.gateOut} onClick={submitGateOutData} />
        </div>
      </div>
      <AlertBox
        show={successAlert}
        setShow={setSuccessAlert}
        title={"Success"}
        className="getOutBtnOff"
        alertMessage={popUpMessages}
      />
      <AlertBox
        show={errorAlert}
        setShow={setErrorAlert}
        title={"Error"}
        alertMessage={popUpMessages}
      />
    </div>
  );
};

export default GateOut;
